import { useSenarioTemplateSet } from "components/scenarioManegement/ScenarioExpand/hook";
import { PageLevel, useConsoleState } from "providers/ConsoleStateProvider";
import { useLoadingState } from "providers/LoadingProvider";
import React from "react";
import { useHistory } from "react-router";
import { Mail, NotificationEvent } from "types/graphqlapi";
import { listMailByNotificationEventIdQuery } from "utils/apis/mail";

export const useMailList = () => {
  const history = useHistory();
  const { setLoading } = useLoadingState();
  const { setScreenName, setPageLevel } = useConsoleState();
  const [mailList, setMailList] = React.useState<Mail[]>([]);

  const fetchMailList = async (
    notificationEvent: NotificationEvent | undefined
  ) => {
    if (!notificationEvent || !notificationEvent.notification_event_type)
      return;
    try {
      const queryResult = await listMailByNotificationEventIdQuery(
        notificationEvent.id
      );

      if (queryResult === undefined) return;

      return queryResult;
    } catch (e) {
      console.error(e);
      alert("エラーが発生しました。");
      setLoading(false);
      history.replace("/auth/login");
    }
  };

  React.useEffect(() => {
    setScreenName("案件詳細");
    setPageLevel(PageLevel.interviewManagement);
  }, []);

  return {
    mailList,
    setMailList,
    fetchMailList,
  };
};
